import CloseIcon from '@mui/icons-material/Close';
import { DialogTitle, DialogTitleProps, IconButton } from '@mui/material';

interface DialogTitleWithCloseIconProps extends DialogTitleProps {
    title: string;
    handleClose: () => void;
}

export const DialogTitleWithCloseIcon = ({ title, handleClose }: DialogTitleWithCloseIconProps) => {
    return (
        <DialogTitle>
            {title}
            <IconButton edge="end" onClick={() => handleClose()}>
                <CloseIcon />
            </IconButton>
        </DialogTitle>
    );
};
